import React from "react";

import ContentCard from "../../../../UI/ContentCard/ContentCard";
import qualityImg from "../../../../assests/images/quality.png";

const VisionQuality = () => (
  <ContentCard
    title="The best quality"
    id="quality"
    image={qualityImg}
    imageTitle="The Quality Matters"
    frontText="We believe the most valuable feature of a garment should be the quality
        instead of a little label on the chest."
    backTextOne="We believe the most valuable feature of a garment should be the overall quality of craftsmanship and
        fabrics instead of a little label on the chest."
    backTextTwo="People have to pay a lot of money for a certain brand name on a garment. But this does not
    automatically come with high quality which you actually could expect when looking at the price tag."
    backTextThree="We want to provide an alternative. We don‘t care about expensive marketing campaigns.
    Instead we put all resources into the quality of our products. We want to build a community together with smart
    people who would rather select perfect and high quality pieces than having a lot of disappointments in
    the wardrobe."
  />
);

export default VisionQuality;



// WEBPACK FOOTER //
// ./src/components/Pages/Vision/Content/VisionQuality.js